import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './TextareaField.styl';

const cx = classNames.bind(styles);

export default function TextareaField(props) {
  const { className, label, name, textareaRef, register, ...otherProps } = props;

  const textareaProps = {
    ...otherProps,
    ref: textareaRef || register,
    name,
    id: name,
  };

  return (
    <div className={cx('TextareaField', className)}>
      {Boolean(label) && (
        <label className={cx('TextareaField__label')} htmlFor={name}>
          {label}
        </label>
      )}
      <textarea {...textareaProps} className={cx('TextareaField__field')} />
    </div>
  );
}

TextareaField.defaultProps = {
  className: '',
  register: null,
};

TextareaField.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  textareaRef: PropTypes.object,
  register: PropTypes.func,
};
